<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <div class="content topicBox" v-if="topicType">
      <myHeader></myHeader>
      <div class="organiza-txt" v-if="topiclistType">
        <div class="organiza-title clear">
          <p :class="headID==1?'select':''" @click="headSub('1')">单题</p>
          <p :class="headID==2?'select':''" @click="headSub('2')">多题</p>
          <p style="margin-left: 20px;font-size: 14px;color: #ccc;">{{headID == 1 ? '单题定义：一段对话对应一道题' : '多题定义：一段对话对应多道题'}}</p>
        </div>
        <div class="organiza-form " v-if="headID == 1">
          <div class="organiza-list" v-for="(item,index) in addObj.topics" :key="(index+1)">
            <div class="organiza-item">
              <p>题目{{(index+1)}}</p>
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="organiza-item">
              <p>上传音频：</p>
              <div class="upload">
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj" 
                    list-type="picture-card"
                    :before-upload="beforeUploadAudio"
                    :on-success="(response, file, fileList)=>{return handleSuccessAudio(response, file, fileList,index)}"
                    :on-progress="handleProgressAudio"
                    :on-remove="(response, file, fileList)=>{return handleRemoveImg(response, file, fileList,index)}">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <audio :src="'https://pic.bi-rong.com/'+item.video" controls v-if="item.video"></audio>
                </div>
            </div>
            <div class="organiza-item">
              <p>难度：</p>
              <select v-model="item.difficulty">
                <option value="">请选择</option>
                <option value="1">基础阶段</option>
                <option value="2">中级阶段</option>
                <option value="3">高级阶段</option>
              </select>
            </div>
            <div class="organiza-item">
              <p>题目类型：</p>
              <select v-model="item.topic_type">
                <option value="">请选择</option>
                <option value="1">校园</option>
                <option value="2">天文</option>
                <option value="3">地理</option>
                <option value="4">人物传记</option>
                <option value="5">文化</option>
                <option value="6">艺术</option>
                <option value="7">发明创造</option>
                <option value="8">历史</option>
                <option value="9">体育运动</option>
                <option value="10">健康</option>
                <option value="11">动植物</option>
                <option value="12">气候</option>
                <option value="13">环境保护</option>
                <option value="14">讲座</option>
                <option value="15">对话</option>
                <option value="16">生活</option>
              </select>
            </div>
            <div class="organiza-item">
              <p>题干标题：</p>
              <textarea v-model="item.label" placeholder="例如：
conversation is followed by three or moreNow you will hearsome comversationgueshons. Choose the beststion and mark the letter ofthe comreetnversation only one time."></textarea>
            </div>
            <div class="organiza-item">
              <p>题干/选项/答案/解析：</p>
              <textarea v-model="item.topic" 
                placeholder="例如：1. What will the students be doing at theaquarium?
(A) Helping the aquarium staff
(B) Attending a show on underwater life
(C) Learning how new exhibits are made
(D) Seeig an exhibit on unusual seacreatures
答案：C
解析：解析内容"></textarea>
            </div>
            
            <div class="organiza-item">
              <p>听力文本：</p>
              <textarea v-model="item.content" 
                placeholder=""></textarea>
            </div>
          </div>
        </div>
        <div class="organiza-form " v-if="headID == 2">
          <div class="organiza-list" v-for="(item,index) in addObj.topics" :key="(index+1)">
            <div class="organiza-item">
              <p>题目{{(index+1)}}</p>
              <!-- <input type="text" v-model="item.topic"> -->
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="organiza-item">
              <p>上传音频：</p>
              <div class="upload">
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj" 
                    list-type="picture-card"
                    :before-upload="beforeUploadAudio"
                    :on-success="(response, file, fileList)=>{return handleSuccessAudio(response, file, fileList,index)}"
                    :on-progress="handleProgressAudio"
                    :on-remove="(response, file, fileList)=>{return handleRemoveImg(response, file, fileList,index)}">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <audio :src="'https://pic.bi-rong.com/'+item.video" controls v-if="item.video"></audio>
                </div>
            </div>
            <div class="organiza-item">
              <p>难度：</p>
              <select v-model="item.difficulty">
                <option value="">请选择</option>
                <option value="1">基础阶段</option>
                <option value="2">中级阶段</option>
                <option value="3">高级阶段</option>
              </select>
            </div>
            <div class="organiza-item">
              <p>题目类型：</p>
              <select v-model="item.topic_type">
                <option value="">请选择</option>
                <option value="1">校园</option>
                <option value="2">天文</option>
                <option value="3">地理</option>
                <option value="4">人物传记</option>
                <option value="5">文化</option>
                <option value="6">艺术</option>
                <option value="7">发明创造</option>
                <option value="8">历史</option>
                <option value="9">体育运动</option>
                <option value="10">健康</option>
                <option value="11">动植物</option>
                <option value="12">气候</option>
                <option value="13">环境保护</option>
                <option value="14">讲座</option>
                <option value="15">对话</option>
                <option value="16">生活</option>
              </select>
            </div>
            <div class="organiza-item">
              <p>题干标题：</p>
              <textarea v-model="item.label" placeholder="例如：
conversation is followed by three or moreNow you will hearsome comversationgueshons. Choose the beststion and mark the letter ofthe comreetnversation only one time."></textarea>
            </div>
            <div class="organiza-item">
              <p>题干/选项/答案/解析：</p>
              <textarea v-model="item.topic" 
              placeholder="10、What does the teacher imply when shesays, “But I wasn't the only one”?
(A) Other people came to the picnic, too.
(B) Many people oyed the boy's cake.
(C) Many peopit cakes to thepicnic.
(D) She brought additional items to share.
答案：C


11、What was the boy’s mother afraid of?
(A) That people would not like the cake
(B) That the cake would not be big enough
(C) That she would not enjoy herself at thepicnic
(D) That she would not have time to makethe cake
答案：B


12、What does the teacher ask the boy todo?
(A) Show her how to bake the cake
(B)Bring her the recipe for the cake
(C) Thank his mother for baking the cake
(D) Invite his mother to the music clubpicnic
答案：D
解析：解析内容"></textarea>
            </div>
            
            <div class="organiza-item">
              <p>听力文本：</p>
              <textarea v-model="item.content" 
                placeholder=""></textarea>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button v-if="headID==2" class="btn btn-add" @click="addTopicSub">添加题目</button>
          <button class="btn btn-sub" @click="topicSub">确定</button>
          <button class="btn btn-close" @click="topicHide">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-form ">
          <div class="organiza-list" v-for="(item,index) in addObj.topics" :key="(index+1)">
            <div class="organiza-item">
              <p>题目{{(index+1)}}</p>
              <!-- <input type="text" v-model="item.topic"> -->
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="organiza-item">
              <p>难度：</p>
              <select v-model="item.difficulty">
                <option value="">请选择</option>
                <option value="1">基础阶段</option>
                <option value="2">中级阶段</option>
                <option value="3">高级阶段</option>
              </select>
            </div>
            <div class="organiza-item">
              <p>题目类型：</p>
              <select v-model="item.topic_type">
                <option value="">请选择</option>
                <option value="1">校园</option>
                <option value="2">天文</option>
                <option value="3">地理</option>
                <option value="4">人物传记</option>
                <option value="5">文化</option>
                <option value="6">艺术</option>
                <option value="7">发明创造</option>
                <option value="8">历史</option>
                <option value="9">体育运动</option>
                <option value="10">健康</option>
                <option value="11">动植物</option>
                <option value="12">气候</option>
                <option value="13">环境保护</option>
                <option value="14">讲座</option>
                <option value="15">对话</option>
                <option value="16">生活</option>
              </select>
            </div>
            <div class="organiza-item">
              <p>阅读素材：</p>
              <!-- <Editor v-model="item.content"/> -->
              <myEditor @input="sourceInput" @imgUpload="imgUpload" :value="item.content" :index="index" @click="sourceClick(index)"/>
            </div>
            <div class="organiza-item">
              <p>题干标题：</p>
              <textarea v-model="item.label" placeholder="例如：
conversation is followed by three or moreNow you will hearsome comversationgueshons. Choose the beststion and mark the letter ofthe comreetnversation only one time."></textarea>
            </div>
            <div class="organiza-item">
              <p>题干/选项/答案/解析：</p>
              <textarea v-model="item.topic" 
              placeholder="例如：1、The environmental club is holding（）next Monday at 3 PM. in the
(A) a bake sale
(B) a bake sale is
(C) and a bake sale
(D) that a bake sale
答案：C


2、hallway outside of the cafeteria. All the money（）will go to the
(A) raised
(B) raising
(C) to raise
(D)was raised
答案：C


3、International Nature Foundation,（）organization that protects endangered
(A) either
(B) what
(C) any
(D)an
答案：C


4、animals. The sale will（）delicious cookies, cupcakes, muffins, and more.
(A) save
(B) select
(C)feature
(D)purchase
答案：C
解析：解析内容"></textarea>
            </div>
            
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-add" @click="addTopicSub">添加题目</button>
          <button class="btn btn-sub" @click="topicSub">确定</button>
          <button class="btn btn-close" @click="topicHide">取消</button>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="content " v-else>
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>标题列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加标题</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543;">
                <span @click="addTitle(item)">
                  添加题目
                </span>
                <span @click="editShow(item)">
                  编辑
                </span>
                <span @click="removeSub(item)">
                  删除 
                </span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加标题':'编辑标题'}}</p>
        <form>
          <div class="write-txt">
            <p>标题名称：</p>
            <input type="text" v-model="buildObj.name">
          </div>
          <div class="write-txt">
            <p>是否试用：</p>
            <el-radio-group v-model="buildObj.is_free">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import myEditor from './../components/comment/wangeditor.vue'
import { getExerList,saveExer,delExer } from "@/assets/js/api";
import { getUploadToken,addExerTopic } from '../assets/js/api';
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'标题名称'},
        {id:3,title:'创建时间'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        mtid:'',
        qpid:'',
        model_id:'',
        title:''
      },
      buildObj:{
        mtid:'',
        qpid:'',
        name:'',
        model_id:'',
        is_free:'1'
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      topicType:false,
      topiclistType:false,
      headID:1,
      addObj:{
        eid:'',
        model_id:'',
        type:1,
        topics:[
          {difficulty:'',topic_type:'',label:'',video:'',topic:'',content:''},
        ]
      },
      uploadObj:{
        token:'',
        key:'',
      },
    };
  },
  components: {
    navBox,
    myHeader,
    myEditor
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.obj.mtid = this.buildObj.mtid = this.$route.query.mtid;
    this.obj.qpid = this.buildObj.qpid = this.$route.query.qpid;
    if(this.$route.query.is_video == 1){
      this.addObj={
        eid:'',
        model_id:'',
        type:1,
        topics:[
          {difficulty:'',topic_type:'',label:'',video:'',topic:'',content:''},
        ]
      }
    } else {
      this.addObj={
        eid:'',
        model_id:'',
        topics:[
          {difficulty:'',topic_type:'',topic:'',content:''},
        ]
      }
    };
    this.obj.model_id = this.buildObj.model_id = this.addObj.model_id = this.$route.query.model_id;
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    getToken(){
      getUploadToken(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          this.uploadObj.token = data.data.token
        }
      })
    },

    beforeUploadAudio(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    
    handleSuccessAudio(response, file, fileList,index){
      this.addObj.topics[index].video = response.key;
      this.loading = false;
      this.uploadObj.key = '';
    },
    
    handleProgressAudio(event, file, fileList){
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
    },
    handleRemoveImg(response, file, fileList,index){
      console.log(index,'==index==')
      this.addObj.topics[index].video = '';
    },


    addTitle(e){
      console.log(e,'dddd');
      var isAudio = this.$route.query.is_video;
      if(isAudio == 1){
        this.topiclistType = true;
        this.addObj.type = this.headID;
      } else {
        this.topiclistType = false;
      };
      this.topicType = true;
      this.addObj.eid = e.eid;
    },

    // 取消
    closeSub(){
      this.buildObj={
        mtid: this.$route.query.mtid,
        qpid: this.$route.query.qpid,
        name:'',
        model_id: this.$route.query.model_id,
        is_free:'1'
      }
      this.showType = '';
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      if(this.buildObj.name == ''){
        that.$message('请填写标题!');
        return false;
      }
      saveExer(that.buildObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.buildObj.name = '';
      if(this.buildObj.eid){
        delete this.buildObj.eid;
      }
      this.dataList = [];
      this.getList();
    },

    getList(){
      var that = this;
      getExerList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.buildObj={
        mtid: this.$route.query.mtid,
        qpid: this.$route.query.qpid,
        name:'',
        model_id: this.$route.query.model_id,
        is_free:'1'
      }
    },

    editShow(e){
      this.showType = 'edit';
      this.buildObj = {
        eid : e.eid,
        is_free : JSON.stringify(e.is_free),
        name : e.name,
      }
      console.log(this.buildObj)
    },

    removeSub(e){
      var that = this;
      delExer({eid:e.eid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    lookTopic(e){
      this.topicType = true;
    },

    topicSub(){
      var that = this;
      console.log(this.addObj,'==dddd==');
      addExerTopic(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          window.location.reload();
        } else {
          that.$message(data.msg);
        }
      })
      console.log(this.addObj,'==addObj==')
    },

    topicHide(){
      var that = this;
      that.topicType = false;
    },

    headSub(i){
      var that = this;
      this.$confirm('请确定当前编辑是否已经提交,否则此次数据将清空, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.headID = this.addObj.type = i;
        if(i == 1){
          that.addObj.topics=[{difficulty:'',topic_type:'',label:'',video:'',topic:'',content:''}];
        } else {
          that.addObj.topics=[{difficulty:'',topic_type:'',label:'',video:'',topic:'',content:''}];
        };
      }).catch(() => {
                  
      });
    },

    addTopicSub(){
      var that = this;
      this.addObj.type = this.headID;
      
      if(this.$route.query.is_video == 1){
        if(this.headID == 1){
          that.addObj.topics.push({difficulty:'',topic_type:'',label:'',video:'',topic:'',content:''});
        } else {
          that.addObj.topics.push({difficulty:'',topic_type:'',label:'',video:'',topic:'',content:''});
        };
      } else {
        that.addObj.topics.push({difficulty:'',topic_type:'',topic:'',content:''});
      };
      console.log(this.addObj);
    },

    removeTopic(e,i){
      var that = this;
      this.addObj.topics.splice(i,1);
    },

    sourceClick(i){
      console.log(i,'==i==')
    },

    sourceInput(value,index) {
      this.addObj.topics[index].content = value;
    },

    imgUpload(type){
      console.log(type,'==type==')
    }
  },

  
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 4 );
}

.el-switch,
.el-radio-group{
  height: 36px;
  width: 225px;
}

.el-radio{
  line-height: 36px;
}

.el-radio__label{
  font-size: 15px;
}

.noClick{
  background-color: #ccc!important;
}

.topicBox .organiza-list{
  margin-top: 30px;
  font-size: 0;
  height: auto;
}

.topicBox .organiza-title p {
  margin-right: 20px;
}

.topicBox .organiza-title p.select {
    font-size: 20px;
    font-weight: 700;
    border-bottom: 5px solid #4c7efb;
}

.topicBox .organiza-title p::before {
  display: none;
}

.topicBox .organiza-item input,
.topicBox .organiza-item p,
.topicBox .organiza-item textarea{
  display: inline-block;
  vertical-align: top;
  padding: 21px 30px;
  box-sizing: border-box;
  width: auto;
}

.topicBox .organiza-item select{
  display: inline-block;
  vertical-align: top;
  margin: 15px 10px;
  padding: 5px 10px;
}

.topicBox .organiza-item input,
.topicBox .organiza-item textarea{
  width: 40%;
  height: 200px;
  border-radius: 5px;
  border: solid 1px #ccc;
  margin: 21px 0;
  font-size: 18px;
}

.topicBox .organiza-item input{
  height: 20px;
  padding: 20px 10px;
  margin: 10px 0;
}

.topicBox .organiza-item .btn-remove{
  background-color: #00D4BF;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;
  margin: 15px 0 0 20px;
}

.topicBox .btnBox{
  font-size: 0;
  margin-top: 20px;
}

.topicBox .btnBox .btn{
  display: inline-block;
  vertical-align: top;
  padding: 10px 20px;
  background-color: #457AFF;
  color: #fff;
  border-radius: 10px;
  margin-right: 20px;
}

.topicBox .btnBox .btn.btn-close{
  background-color: #CBCBCB;
}

.organiza-form{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.organiza-item{
  margin-top: 30px;
}

.upload{
  display: inline-block
}

.upload audio{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/exam/title.vue